import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { MatTableDataSource, MatDialog, PageEvent } from '@angular/material';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ComponentPageTitle } from 'src/app/page-title/page-title.component';
import { AppServiceService } from 'src/app/services/app-service.service';
import { BusquedaService } from '../busqueda.service';
import { CreateService } from '../createservice';
import { CreateRolComponent } from '../create-rol/create-rol.component';
import { GatewayService } from 'src/app/gateway.service';
import { ConfirmacionComponent } from '../confirmacion/confirmacion.component';
import { FiltroPaisService } from '../filtro-pais.service';
import { LocalSaveService } from 'src/app/services/local-save-service.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
	selector: 'app-rol',
	templateUrl: './rol.component.html',
	styleUrls: ['./rol.component.scss']
})
export class RolComponent implements OnInit {
  private destroy$ = new Subject<void>();
	// campanaColumns: string[] = ['IDROL', 'NOMBREROL', 'DESCRIPCION', 'PAIS', 'ACCION'];
	// campanaColumns: string[] = [ 'NOMBREROL', 'DESCRIPCION', 'PAIS'];
	campanaColumns: string[] = [ 'NOMBREROL', 'DESCRIPCION'];
	dataSource = new MatTableDataSource<any>();
	private subscription: Subscription;
	private subscriptioncreate: Subscription;
	private subscriptionpais: Subscription;
	FILTER; resultsLength = 0;
	pageSize = 10;
	idpais;
	pageEvent: PageEvent;

	constructor(
		private router: Router,
		private spinner: NgxSpinnerService,
		private gateway: GatewayService,
		public pageTitle: ComponentPageTitle,
		public _appservice: AppServiceService,
		public _busqueda: BusquedaService,
		public _create: CreateService,
		private dialog: MatDialog,
		public _filtroPais: FiltroPaisService,
		private localSave: LocalSaveService
	) { }

	ngOnInit() {
		const user = this.localSave.get('usuarioPGV');
		
		if (!user || user.idrol != 16) {
			this.router.navigate(['/home']);
		}

		this.idpais = this.localSave.get('pais');
		this.get(0);
		this.pageTitle.title = 'Roles';
		// this.loadUsuarios();
		this.subscription = this._busqueda.notifyObservable$.pipe(takeUntil(this.destroy$)).subscribe(
			res => {
				this.filtrartipologia(res.filtro);
			});
		this.subscriptioncreate = this._create.notifyObservable$.pipe(takeUntil(this.destroy$)).subscribe(
			res => {
				this.createRol();
			});
		this.subscriptionpais = this._filtroPais.notifyObservable$.pipe(takeUntil(this.destroy$)).subscribe(
			res => {
				this.idpais = res.IDPAIS;
				this.get(0);
			}
		);
	}

	// ============== FILTRO ==============
	filter = '';
	public keyDownFunction(event) {
		if (event.keyCode == 13) {
			this.filtrogeneral();
		} else if (event.keyCode == 8 && this.filter == '') {
			this.filtrogeneral();
		}
	}
	public filtrogeneral() {
		this._busqueda.notificarBusqueda({ filtro: this.filter });
	}

	cambioElementos(event?:PageEvent) { 
		this.get(event.pageIndex);
	}

	get(page) {
		this.spinner.show();
		this.gateway.get('getrol', { NUM_PAGINA: page, FILTRO: this.FILTER, NUM_ELEMENTOS: this.pageSize, IDPAIS: this.idpais })
		.then((result) => {
			let aux:any = result;
			//console.log(aux.rows);
			this.dataSource = aux.rows;
			//this.resultsLength = 3;//result[1][0].TOTAL;
			this.gateway.get('getrolcount', { NUM_PAGINA: page, FILTRO: this.FILTER, NUM_ELEMENTOS: this.pageSize, IDPAIS: this.idpais }).then((result:any) => {
				//console.log(result.rows);
				this.resultsLength = result.rows[0].total;
				 this.spinner.hide();
			});
		}
		).catch(function (e) {
		});
	}

	ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
		this.subscription.unsubscribe();
		this.subscriptioncreate.unsubscribe();
		this.subscriptionpais.unsubscribe();
	}

	createRol() {
		const dialogRef = this.dialog.open(CreateRolComponent, {
			maxWidth: '90vw',
			width: '620px',
			minHeight: '40vh',
			data: { operacion: 'Crear', rol: { IDPAIS: this.idpais } },
			disableClose: true
		});

		dialogRef.afterClosed().subscribe(result => {
			this.get(0);
		});
	}

	filtrartipologia(data) {
		
		this.FILTER = data;
		this.get(0)
	}

	edit(element) {
		const dialogRef = this.dialog.open(CreateRolComponent, {
			maxWidth: '90vw',
			width: '620px',
			minHeight: '40vh',
			data: { operacion: 'Editar', rol: element },
			disableClose: true
		});

		dialogRef.afterClosed().subscribe(result => {
			this.get(0);
		});
	}

	delete(element) {
		const dialogRef = this.dialog.open(ConfirmacionComponent, {
			disableClose: true,
			width: '300px',
			data: { operacion: 'deleterol', id: { IDROL: element.IDROL } }
		});

		dialogRef.afterClosed().subscribe(() => {
			this.get(0);
		});
	}

}

